import { ProductFormatEnum } from '../../../../../store/apiLibx';
import { TFunction } from 'i18next';

export const mapProductFormat = (productFormat: ProductFormatEnum, t: TFunction) => {
    const productFormatData = {
        current: t(`yourLocalContent.yourTitles.dropdowns.productFormat.${productFormat}`, {
            defaultValue: t('yourLocalContent.yourTitles.select')
        }),
        currentKey: productFormat,
        all: {
            PDF: t('yourLocalContent.yourTitles.dropdowns.productFormat.PDF'),
            EPUB: t('yourLocalContent.yourTitles.dropdowns.productFormat.EPUB')
        }
    };

    return { productFormatData };
};
